import { render, staticRenderFns } from "./EditVdoLiveSet.vue?vue&type=template&id=241b21d9&scoped=true&"
import script from "./EditVdoLiveSet.vue?vue&type=script&lang=js&"
export * from "./EditVdoLiveSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241b21d9",
  null
  
)

export default component.exports